export function isSessionStorageSupported() {
    try {
        const key = "session-test-key";
        const val = "test-value";
        window.sessionStorage.setItem(key, val);
        const read = window.sessionStorage.getItem(key);
        window.sessionStorage.removeItem(key);
        return read === val;
    }
    catch {
        return false;
    }
}
